import { Injectable } from '@angular/core';
import { UserRegistrationDataService } from './user-registration-data.service';
import { UserModel } from './model/user-registration.model';

@Injectable({
  providedIn: 'root',
})
export class UserRegistrationMockService implements UserRegistrationDataService {
  userRegistration: any;
  counter = 0;

  constructor() {
    this.userRegistration = this.setUserRegistration();
  }

  public getUserRegistration(): Promise<UserModel> {
    // return this.simulateError();
    return Promise.resolve(this.userRegistration);
  }

  protected setUserRegistration() {
    return {
      data: {
        id_investidor: "be0f82ef-e10c-4f11-97a9-ea37dea0bc77",
        situacao:{
          id_pessoa: "5ba0f57a-0a3c-4b15-a147-19f5461e707b",
          id_fluxo: "1",
          descricao_fluxo: "cadastro",
          redireciona_app_itau: false
        },
        dados_contato: {
          telefone: '11950931996',
          informacoes_completas: true,
          email: 'mock@mock.com',
          campos_editaveis: ['email', 'telefone']
        },
        dados_pessoais: {
          conta_ion: false,
          cidade_nascimento: 'SAO PAULO',
          cidade_nascimento_codigo: '3550308',
          cidade_nascimento_descricao: 'SAO PAULO',
          cpf: '00029513324834',
          data_nascimento: '01/12/1970',
          documento_codigo: '552',
          documento_descricao: 'RN',
          documento_numero: '401069667',
          documento_data_expedicao: '09/10/2017',
          documento_estado_expedicao_descricao: 'SAO PAULO',
          documento_estado_expedicao_sigla: 'SP',
          genero_codigo: '2',
          genero_descricao: 'Masculino',
          genero_sigla: 'M',
          informacoes_completas: false,
          nacionalidade_codigo: '648',
          nacionalidade_descricao: 'BRASILEIRA',
          nome: 'PMD Bashar Marks MOCK',
          nome_fantasia_apelido: 'PMD MOCK',
          nome_completo_documento: 'PMD Bashar Marks MOCK',
          nome_mae: 'marte amore MOCK',
          orgao_expedidor_codigo: '347',
          orgao_expedidor_descricao: 'SSP',
          pais_nascimento_descricao: 'BRASIL',
          pais_nascimento_sigla: 'BR',
          // regiao_nascimento_fundacao: "ESTADOsS UNIDOS",
          uf_nascimento_descricao: 'SAO PAULO',
          uf_nascimento_sigla: 'SP',
          vinculo_corretora: false,
          idade: "18"
        },
        endereco: {
          // campos_editaveis: ['cep', 'rua', 'numero', 'complemento', 'bairro', 'estado', 'cidade'],
          campos_editaveis: [],
          bairro: 'Centro',
          cep: '00000-001',
          cidade: 'São Paulo',
          complemento: 'casa 2',
          estado: 'SP',
          informacoes_completas: false,
          // numero: '5533',
          rua: 'Boa Vista'
        },
        estado_civil: {
          campos_editaveis: ['estado_civil', 'conjuge_nome', 'conjuge_cpf'],
          // conjuge_cpf: '00068300648488',
          // conjuge_nome: 'mosc',
          estado_civil: '617',
          estado_civil_descricao: 'SOLTEIRO',
          conjuge_estrangeiro: false,
          informacoes_completas: false
        },
        dados_profissionais: {
          campos_editaveis: ["profissao_codigo", "origem_renda_codigo", "empresa_nome", "empresa_cnpj","nif"],
          informacoes_completas: false,
          empresa_nome: "ITAU UNIBANCO HOLDING S.A",
          origem_renda_codigo: "11829",
          origem_renda_descricao: "EMPREGADO EMPRESA PRIVADA",
          profissao_codigo: "961",
          profissao_descricao: "ADVOGADO",
          empresa_cnpj: "60872504000123",
        },
        patrimonio: {
          campos_editaveis: ['patrimonio', 'renda', 'pais_residencia_fiscal_sigla', 'nif', 'sem_renda_faturamento', 'sem_patrimonio'],
          informacoes_completas: true,
          residencias_fiscais: [],
          // residencias_fiscais: [
          //   {
          //     data_residencia_fiscal: '02/02/1996',
          //     pais_residencia_fiscal_sigla: 'UY',
          //     pais_residencia_fiscal_nome: 'URUGUAI',
          //     numero_identificacao_fiscal: '12IS5678'
          //   }
          // ],
          pais_residencia_fiscal_nome: 'BRASIL',
          pais_residencia_fiscal_sigla: "BR",
          renda_obrigatoria: true,
          patrimonio_obrigatorio: true,
          patrimonio: '0,00',
          renda: '5000,99',
          sem_patrimonio: true,
          sem_renda_faturamento: false
        }
      }
    };
  }

  protected setUserRegistrationError() {
    return {
      errorData: {
        code: 500,
        message: '',
        data: {
          statuscode: '500',
          message: 'error'
        }
      },
      rel: 'user-cad-data'
    };
  }

  private simulateError() {
    this.counter = this.counter + 1;

    if (this.counter <= 1) {
      this.userRegistration = this.setUserRegistrationError();
      return Promise.resolve(this.userRegistration );
    } else {
      this.userRegistration = this.setUserRegistration();
      return Promise.resolve(this.userRegistration);
    }
  };
}
